import { render, staticRenderFns } from "./DadosGeraisTab.vue?vue&type=template&id=6d9c12ea"
import script from "./DadosGeraisTab.vue?vue&type=script&lang=js"
export * from "./DadosGeraisTab.vue?vue&type=script&lang=js"
import style0 from "./DadosGeraisTab.vue?vue&type=style&index=0&id=6d9c12ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports